import { cx } from 'class-variance-authority';

import styles from './main.module.css';

export const Main: React.FC<React.HtmlHTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => {
  return (
    <div {...props} className={cx(styles.main, className)}>
      {children}
    </div>
  );
};
